import {Route, Routes } from "react-router-dom";
import './App.css';
import Header from './layouts/header';
import Footer from './layouts/footer';
import Accueil from './pages/accueil';
import Privacy from "./pages/privacy";
import Use from "./pages/use";
import Reimbursement from "./pages/Reimbursement";
import { LanguageProvider } from './i18n/LanguageContext';

function Site({ lang }) {
  return (
    <LanguageProvider lang={lang}>
      <Header />
      <Routes>
        <Route path="/" element={<Accueil />}/>
        <Route path="/privacypolicy" element={<Privacy />}/>
        <Route path="/termsandconditions" element={<Use />}/>
        <Route path="/refundpolicy" element={<Reimbursement />}/>
      </Routes>
      <Footer/>
    </LanguageProvider>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/es/*" element={<Site lang="es" />} />
      <Route path="/*" element={<Site lang="fr" />} />
    </Routes>
  );
}

export default App;
